import * as React from 'react';
import cn from 'classnames';

import {
  ContentModalProps,
  ModalSize
} from 'shared/newEntities/components/modals';

import Modal from '../Modal';

import contentModalStyles from './ContentModal.modules.scss';

const ContentModal = React.forwardRef(
  (
    {
      children,
      fixHeight = true,
      fullScreen = false,
      fullScreenMobile = false,
      className,
      size = ModalSize.l,
      ...rest
    }: ContentModalProps,
    ref: React.MutableRefObject<HTMLDivElement | null>
  ) => {
    const effectiveFixHeight = fixHeight || fullScreen;

    return (
      <Modal
        {...rest}
        fullScreenMobile={fullScreenMobile}
        ref={ref}
        className={cn(
          contentModalStyles['content-modal'],
          effectiveFixHeight && contentModalStyles['content-modal_fix-height'],
          fullScreen && contentModalStyles['content-modal_full-screen'],
          fullScreenMobile &&
            contentModalStyles['content-modal_full-screen-mobile'],
          contentModalStyles[`content-modal_${size}`],
          className
        )}
      >
        {children}
      </Modal>
    );
  }
);

export default ContentModal;
